module.exports = __webpack_public_path__ + "static/img/jjcThird.4fec1cfa.png";